import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';
import userReducer from './slices/user/userSlice';
// import searchReducer from './slices/search/searchSlice';
import teamReducer from './slices/team/teamSlice';
import designationReducer from './slices/designation/designationSlice';
import shiftReducer from './slices/shift/shiftSlice';
import wfhReducer from './slices/wfh/wfhSlice';
import roleReducer from './slices/role/roleSlice';
import attendanceReducer from './slices/attendance/attendanceSlice';
import analyticsReducer from './slices/analytics/analyticsSlice';
import holidayReducer from './slices/holiday/holidaySlice';
import templateReducer from './slices/mail/mailSlice';
import requestLeaveReducer from './slices/requestleave/requestLeaveSlice';
import { apiSlice } from './slices/apiSlice';
import { toastMiddleware } from './middleware/toastMiddleware';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    employee: userReducer,
    // searchedUsers: searchReducer,
    team: teamReducer,
    designation: designationReducer,
    shift: shiftReducer,
    wfh: wfhReducer,
    role: roleReducer,
    attendance: attendanceReducer,
    analytics: analyticsReducer,
    holiday: holidayReducer,
    mailTemplate: templateReducer,
    requestLeave: requestLeaveReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .prepend(toastMiddleware.middleware),
  devTools: true,
});

export default store;